import { render } from "./ProjetsView.vue?vue&type=template&id=8d5d6094&scoped=true"
import script from "./ProjetsView.vue?vue&type=script&lang=js"
export * from "./ProjetsView.vue?vue&type=script&lang=js"

import "./ProjetsView.vue?vue&type=style&index=0&id=8d5d6094&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5d6094"]])

export default __exports__